export default __webpack_public_path__ + "static/media/44k.d3ea1dd5.yaml";